document.addEventListener("DOMContentLoaded", ()=> {
  const addToCartBtn = document.querySelector(".product__info-container button.product-form__submit");
  const addToCartBtnContainer = document.querySelector(".product__info-container .product-form__buttons");
  const customNoteRequiredInputs = document.querySelectorAll(".product__info-container input.custom-note-input[required]");
  const productForm = document.querySelector(".product-form form");

  if (customNoteRequiredInputs.length > 0) {
    addToCartBtn.classList.add("no-pointer-events");
    customNoteRequiredInputs.forEach(item => {
      item.addEventListener("keyup", (e)=> {
        //e.target.value = e.target.value.slice(0, e.target.maxLength);
        const requiredEmptyInputs = [...customNoteRequiredInputs].filter((item) => item.value.length === 0);
        if (requiredEmptyInputs.length === 0) {
          addToCartBtn.classList.remove("no-pointer-events");
        }
        else {
          addToCartBtn.classList.add("no-pointer-events");
        }
      });
    });

    addToCartBtnContainer.addEventListener("click", ()=> {
      const requiredEmptyInputs = [...customNoteRequiredInputs].filter((item) => item.value.length > 0);
      if (requiredEmptyInputs.length > 0) {
        addToCartBtn.classList.remove("no-pointer-events");
        addToCartBtn.click();
      }
      else {
        //customNoteRequiredInputs[0].checkValidity();
        customNoteRequiredInputs[0].reportValidity();
        window.scrollBy(0, -160);
      }
    });
  }

  /*const footerLogo = document.querySelector("footer .footer-block__image-wrapper img");
  footerLogo.style.cursor = "pointer";
  footerLogo.addEventListener("click", ()=> {
    window.location.href = "/";
  });*/
});